<template>
  <div class="pagination">
    <md-button class="md-icon-button md-dense" @click="first">
      <md-icon>keyboard_double_arrow_left</md-icon>
    </md-button>
    <md-button class="md-icon-button md-dense" @click="previous">
      <md-icon>keyboard_arrow_left</md-icon>
    </md-button>
    <div class="text">
      <span>{{ text }}</span>
    </div>
    <md-button class="md-icon-button md-dense" @click="next">
      <md-icon>keyboard_arrow_right</md-icon>
    </md-button>
    <md-button class="md-icon-button md-dense" @click="last">
      <md-icon>keyboard_double_arrow_right</md-icon>
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    text: {
      type: String,
      default: '',
    }
  },
  methods: {
    first() {
      this.$emit('first');
    },
    previous() {
      this.$emit('previous');
    },
    next() {
      this.$emit('next');
    },
    last() {
      this.$emit('last');
    },
  }
}
</script>

<style scoped>
.pagination {
  display: flex;
  align-items: center;
}
</style>